/**
 * Parsea la respuesta de un endpoint de comparsa, lanzando si el backend
 * rechazó la petición. `AllExceptionFilter` (backend) devuelve HTTP 200 en
 * TODO error de negocio (400/403/404…) con `success: false` en el body — el
 * status HTTP real NO refleja el error salvo un 500 genuino. Comprobar solo
 * `response.ok` deja pasar como éxito un rechazo real del backend.
 */
const parseArcaResponse = async <T = unknown>(response: Response): Promise<T> => {
	const body = await response.json().catch(() => ({}));

	if (!response.ok || body.success === false) {
		const message = (body.message as string | undefined) || `HTTP ${response.status}`;
		throw new Error(message);
	}

	return body;
};

export default parseArcaResponse;
